import { removeSensitiveData as serviceRemoveSensitiveData } from '@atlassian/conversation-assistant-service/services/assistance-service/utils/data';
import { type StoreAssistant } from '@atlassian/conversation-assistant-store/controllers/chat/types';

export const removeSensitiveData = (message: StoreAssistant): StoreAssistant => ({
	...message,
	content: serviceRemoveSensitiveData(message.content),
});
